import TestPurchase from "./TestPurchase";

export default TestPurchase;
